var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"map-container"}},[_c('vue-plotly',{attrs:{"data":_vm.chart.traces,"layout":_vm.chart.layout,"options":_vm.chart.options,"autoResize":true,"watchShallow":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }